import { WithdrawalRequest } from './types';

/**
 * Format amount to display in dollars
 */
export const formatAmount = (amount: number): string => {
  return `$${amount.toFixed(2)}`;
};

/**
 * Format date to display
 */
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

/**
 * Transform API response to WithdrawalRequest format
 * API returns withdrawal request with owner info
 */
export const transformWithdrawalData = (data: any): WithdrawalRequest => {
  return {
    id: data.id,
    created_at: data.created_at,
    amount: data.amount,
    description: data.description,
    status: data.status,
    address: data.address,
    owner: {
      id: data.owner?.id || '',
      name: data.owner?.name || 'Unknown',
      avatar: data.owner?.avatar,
      lvl: data.owner?.lvl || 'new',
      tg_tag: data.owner?.tg_tag,
    },
  };
};
